module.exports = __webpack_public_path__ + "static/media/toll-road_v3.c359864c.png";